import { url, tokenRef } from "api";

// Partner management: the company's partner organisations and their people
// across all its projects (company admins / super admins; gated server-side).
const headers = () => {
  const h = { "Content-Type": "application/json" };
  const t = localStorage.getItem(tokenRef);
  if (t) h.Authorization = `Bearer ${t}`;
  return h;
};
const handle = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.err || "Request failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

export const getPartnerDirectory = () =>
  fetch(`${url}/partner-directory`, { headers: headers() }).then(handle);
export const addPartnerPerson = (partnerId, body) =>
  fetch(`${url}/partner-directory/${partnerId}/people`, { method: "POST", headers: headers(), body: JSON.stringify(body) }).then(handle);
export const updatePartnerPerson = (partnerId, body) =>
  fetch(`${url}/partner-directory/${partnerId}/people`, { method: "PUT", headers: headers(), body: JSON.stringify(body) }).then(handle);
// Give a listed user a login. Creates the account and EMAILS NOBODY - the
// server uses utils/autoAccount.ensureUserForEmail, so this page keeps its
// promise that nothing here reaches anyone's inbox.
export const grantPartnerAccount = (partnerId, email) =>
  fetch(`${url}/partner-directory/${partnerId}/people/account`, { method: "POST", headers: headers(), body: JSON.stringify({ email }) }).then(handle);
// Which of the partner's projects ONE person is on. The server marks a local
// removal (rosterRemoved) as well as deleting the entry: "taken off this
// project on purpose", which the project's "Add from <partner>'s people"
// picker then leaves out unless asked.
export const setPartnerPersonProjects = (partnerId, email, projectIds) =>
  fetch(`${url}/partner-directory/${partnerId}/people/projects`, { method: "PUT", headers: headers(), body: JSON.stringify({ email, projectIds }) }).then(handle);
export const removePartnerPerson = (partnerId, email) =>
  fetch(`${url}/partner-directory/${partnerId}/people?email=${encodeURIComponent(email)}`, { method: "DELETE", headers: headers() }).then(handle);

// ONE PERSON'S ACCESS, and changing it (owner, 2026-10-05).
//
// Its own pair of routes rather than the general /permissions endpoints:
// those are not scoped to a company's own partners, and this dialog is
// handed to every company admin. The server decides what may be changed
// and sends that allowlist with the answer, so there is no second copy of
// it here to drift.
export const getPartnerAccess = (email) =>
  fetch(`${url}/partner-directory/people/access?email=${encodeURIComponent(email)}`, { headers: headers() }).then(handle);
export const setPartnerPermissions = (email, { add = [], remove = [] }) =>
  fetch(`${url}/partner-directory/people/permissions`, {
    method: "PUT", headers: headers(), body: JSON.stringify({ email, add, remove }),
  }).then(handle);
